export default "__VITE_ASSET__duU1gwDc__"